<template>
  <div id="app">
    <!-- <div id="nav">
      <router-link to="/foo">foo</router-link>|
      <router-link to="/about">About</router-link>
    </div>
    <v-fade-transition mode="out-in">
      <router-view></router-view>
    </v-fade-transition>-->

    <main-layout :items="items" v-if="showLayout === 'main'">
      <v-fade-transition mode="out-in">
        <router-view></router-view>
      </v-fade-transition>
    </main-layout>
    <alone-layout v-if="showLayout === 'alone'">
      <router-view name="alone" />
    </alone-layout>
    <blank-layout v-if="showLayout === 'blank'">
      <router-view name="blank" />
    </blank-layout>
    <liff-layout v-if="showLayout === 'liff'">
      <router-view name="liff" />
    </liff-layout>
  </div>
</template>

<style>
tbody tr.v-data-table__selected {
  background: #b2ebf2 !important;
}
html {
  font-family: "Noto Sans TC", sans-serif;
}
.pointer {
  cursor: pointer;
}
</style>

<script>
import MainLayout from "./views/MainLayout.vue";
import AloneLayout from "./views/AloneLayout.vue";
import BlankLayout from "./views/BlankLayout.vue";
import LiffLayout from "./views/LiffLayout.vue";

export default {
  components: {
    MainLayout,
    AloneLayout,
    BlankLayout,
    LiffLayout
  },
  data: () => ({
    showLayout: "",
    adminItems: [
      {
        title: "寵物管理",
        path: "/petManage",
        icon: "mdi-paw"
      },
      {
        title: "帳號管理",
        path: "/accountManage",
        icon: "mdi-account"
      },
      {
        title: "使用說明",
        path: "/guideline",
        icon: "mdi-tools"
      }
    ],
    employeeItems: [
      {
        title: "寵物管理",
        path: "/petManage",
        icon: "mdi-paw"
      },
      {
        title: "帳號管理",
        path: "/accountManage",
        icon: "mdi-account"
      },
      {
        title: "使用說明",
        path: "/guideline",
        icon: "mdi-tools"
      }
    ],
    superAdminItems: [
      {
        title: "診所管理",
        path: "/clinicManage",
        icon: "mdi-hospital-box"
      }
      // {
      //   title: "資材管理",
      //   parent: "/asset",
      //   icon: "mdi-dog-side",
      //   items: [
      //     {
      //       title: "肥料資材",
      //       icon: "mdi-dog-side",
      //       path: "/asset/fertilizer"
      //     },
      //     {
      //       title: "防治資材",
      //       icon: "mdi-dog-side",
      //       path: "/asset/pesticide"
      //     },
      //     { title: "其他資材", icon: "mdi-dog-side", path: "/asset/other" }
      //   ]
      // }
    ]
  }),
  watch: {
    $route(to) {
      if (this.$my.isLogin()) {
        switch (this.$my.getPermission()) {
          case "role_admin":
            this.items = this.adminItems;
            break;
          case "role_employee":
            this.items = this.employeeItems;
            break;
          case "role_superadmin":
            if (this.$my.getClinic()) {
              //superadmin switch clinic to review
              this.items = this.adminItems;
            } else {
              this.items = this.superAdminItems;
            }
            break;
          default:
            this.items = this.employeeItems;
        }
      }
      //console.log("to:" + JSON.stringify(to));
      this.showLayout = to.meta.renderAt;
    }
  },
  mounted: function() {
    console.log("mounted");
  },
  created() {
    console.log("created");
  }
};
</script>
